/* Shopify filters before pagination; Liquid also checks each variant before rendering. */
(() => {
  const normalize = (search, isSearch = false) => {
    const params = new URLSearchParams(search);
    if (isSearch) params.set('options[unavailable_products]', 'hide');
    else params.set('filter.v.availability', '1');
    return params.toString();
  };
  window.SummitStock = { normalize };
  const template = document.querySelector('main[data-template]')?.dataset.template;
  if (template !== 'collection' && template !== 'search') return;
  const params = new URLSearchParams(location.search);
  const key = template === 'search' ? 'options[unavailable_products]' : 'filter.v.availability';
  const required = template === 'search' ? 'hide' : '1';
  if (params.getAll(key).length === 1 && params.get(key) === required) return;
  const url = new URL(location.href);
  url.search = normalize(url.search, template === 'search');
  // Adding a filter changes the page count; an old page can now be out of range.
  url.searchParams.delete('page');
  location.replace(url.href);
})();
